import React, { useEffect } from 'react';
import './AchievementNotification.css';

export const AchievementNotification = ({ achievements, onClose }) => {
  useEffect(() => {
    if (achievements.length > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // Auto-close after 5 seconds

      return () => clearTimeout(timer);
    }
  }, [achievements, onClose]);

  if (achievements.length === 0) return null;

  return (
    <div className="achievement-notifications">
      {achievements.map((achievement, index) => (
        <div
          key={achievement.id}
          className="achievement-notification"
          style={{ animationDelay: `${index * 100}ms` }}
        >
          <div className="achievement-notification-header">
            <span className="achievement-notification-title">🎉 Achievement Unlocked!</span>
            <button className="achievement-notification-close" onClick={onClose}>
              ✕
            </button>
          </div>
          <div className="achievement-notification-content">
            <div className="achievement-notification-icon">{achievement.icon}</div>
            <div className="achievement-notification-details">
              <div className="achievement-notification-name">{achievement.name}</div>
              <div className="achievement-notification-description">
                {achievement.description}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
